export default function getPageLoadTime(component) {
    return new Date() - window.observedStart;
}
